import { stepPlace } from "./navigation";
import { reducedMotion } from "./motion_pref";

// swipe sideways on a phone to move to the next or previous place in the station. it only claims a clear,
// mostly horizontal flick, never one that starts on an edge (the system Back gesture), inside an input, a canvas,
// a scrolling row, a dialog or the home rack while arranging

const MIN_X = 64;
const EDGE = 28;
let startX = 0;
let startY = 0;
let startT = 0;
let tracking = false;

function blocked(target: Element | null): boolean {
  if (!target) return true;
  if (target.closest("input, textarea, select, canvas, [contenteditable='true'], [data-noswipe], .viewer:not([hidden]), .modal:not([hidden]), .wb-editor:not([hidden]), .rack.arranging, .kanban, .tuner, #dock, #launcher")) return true;
  // a row that scrolls sideways keeps its own swipes
  for (let node: Element | null = target; node && node !== document.body; node = node.parentElement) {
    if (node.scrollWidth > node.clientWidth + 4 && /(auto|scroll)/.test(getComputedStyle(node).overflowX)) return true;
  }
  return false;
}

export function setupSwipeNav(): void {
  if (!matchMedia("(pointer: coarse)").matches) return;
  const content = document.getElementById("content");
  if (!content) return;
  content.addEventListener("pointerdown", (event) => {
    tracking = event.pointerType === "touch" && event.clientX > EDGE && event.clientX < window.innerWidth - EDGE && !blocked(event.target as Element);
    startX = event.clientX;
    startY = event.clientY;
    startT = performance.now();
  });
  content.addEventListener("pointerup", (event) => {
    if (!tracking) return;
    tracking = false;
    const dx = event.clientX - startX;
    const dy = event.clientY - startY;
    if (Math.abs(dx) < MIN_X || Math.abs(dx) < Math.abs(dy) * 2 || performance.now() - startT > 700) return;
    if (window.getSelection()?.toString()) return;
    // swiping left reveals the next place, like turning a page
    if (!stepPlace(dx < 0 ? 1 : -1) && !reducedMotion()) {
      content.classList.remove("swipe-end");
      void content.offsetWidth;
      content.classList.add("swipe-end");
    }
  });
  content.addEventListener("pointercancel", () => {
    tracking = false;
  });
  content.addEventListener("animationend", () => content.classList.remove("swipe-end"));
}
